import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FaSignOutAlt, FaUser, FaStore, FaShieldAlt, FaExchangeAlt } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';

const Header: React.FC = () => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
  };

  const switchToAdminView = () => {
    navigate('/admin/postos');
  };

  return (
    <header className="bg-gradient-to-br from-[#1a2332] to-[#253547] text-white px-4 shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto flex justify-between items-center h-16">
        {/* Left Section */}
        <div className="flex items-center gap-6">
          {/* Brand */}
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="AbasteceMais" className="w-8 h-8 object-contain" />
            <h1 className="text-lg font-bold bg-gradient-to-br from-[#089453] to-[#84CC34] bg-clip-text text-transparent hidden md:block">
              AbasteceMais
            </h1>
            <span className="bg-[#089453]/15 text-[#089453] px-2 py-0.5 rounded-full text-[10px] font-medium hidden xl:inline-block">
              Painel do Posto
            </span>
          </div>

          {/* Navigation */}
          <nav className="flex items-center gap-1">
            <NavLink
              to="/postos"
              className={({ isActive }) =>
                `flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-all duration-200 ${
                  isActive
                    ? 'text-[#089453] bg-[#089453]/10'
                    : 'text-white/60 hover:text-white hover:bg-white/5'
                }`
              }
            >
              <FaStore className="text-sm" />
              <span>Meus postos</span>
            </NavLink>
          </nav>
        </div>

        {/* Right Section */}
        <div className="flex items-center gap-2">
          {isAdmin && (
            <>
              <div className="hidden xl:flex items-center gap-1.5 px-2 py-1 bg-red-500/10 border border-red-500/30 rounded text-[10px] text-red-400 font-medium">
                <FaShieldAlt className="text-xs" />
                <span>Admin</span>
              </div>
              <button
                onClick={switchToAdminView}
                className="hidden md:flex items-center gap-1.5 px-2.5 py-1 bg-gradient-to-br from-red-500 to-red-600 text-white rounded text-xs font-medium transition-all duration-200 hover:shadow-md"
                title="Voltar à Área Admin"
              >
                <FaExchangeAlt className="text-xs" />
                <span>Área Admin</span>
              </button>
            </>
          )}

          {/* User Info */}
          <div className="flex items-center gap-2 px-2 py-1 bg-white/5 rounded-md">
            <FaUser className="text-sm text-[#089453]" />
            <div className="hidden lg:flex flex-col">
              <span className="text-xs font-semibold leading-tight">{user?.fullName || 'Usuário'}</span>
              <span className="text-[9px] text-gray-400 uppercase leading-tight">{user?.nivelAcesso}</span>
            </div>
          </div>

          {/* Logout Button */}
          <button
            onClick={handleLogout}
            className="flex items-center gap-1.5 bg-red-500/10 border border-red-500/30 text-red-400 px-2.5 py-1 rounded text-xs font-medium transition-all duration-200 hover:bg-red-500/20 hover:border-red-400"
            title="Sair"
          >
            <FaSignOutAlt className="text-xs" />
            <span className="hidden sm:inline">Sair</span>
          </button>
        </div>
      </div>

    </header>
  );
};

export default Header;
